import { gql } from '@apollo/client';

const GET_STUDENT_PROGRESS = gql`
  query studentProgress($where: StudentProgressDataWhereInput!) {
    studentProgress(where: $where) {
      student {
        id
        firstName
        lastName
      }
      characterProgress {
        characterId
        activityCompletedCount
        activityTotalCount
        readingLogCount
        bookReadCount
      }
    }
  }
`;

export default GET_STUDENT_PROGRESS;
